import { useTheme } from '@emotion/react'
import { BarLoader } from 'react-spinners'

const HorizontalLoader = () => {
  const theme = useTheme()
  return <BarLoader color={theme.loader.loaderColor} />
}

export default HorizontalLoader
